import { IModel } from '../@types/models/model';
import coreFields from './helpers/coreFields';

const Radionucleids: IModel = {
  title: 'Radionucleids',
  apiPath: 'chem/radionucleids',
  forms: {
    default: {
      fields: ['id'],
    },
  },
  listViews: {
    default: {
      fields: ['id', 'symbol', 'title', 'activity_bq_kg', 'activity_bq_kg_lower', 'activity_bq_kg_higher'],
      hidden: ['id', 'activity_bq_kg_lower', 'activity_bq_kg_higher']
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'Title',
      source: 'title',
      ttoken: 'chem:elements.title',
      type: 'text',
      filter: true,
    },
    {
      title: 'Symbol',
      source: 'symbol',
      ttoken: 'chem:elements.symbol',
      type: 'text',
      filter: true,
    },
     {
      title: 'Activity (Bq/kg)',
      source: 'activity_bq_kg',
      ttoken: 'chem:elements.activity_bq_kg',
      type: 'text',
      filter: true,
    },
    {
      title: 'Activity (Bq/kg) - Lower bound',
      source: 'activity_bq_kg_lower',
      ttoken: 'chem:elements.activity_bq_kg_lower',
      type: 'numeric',
      filter: true,
    },
    {
      title: 'Activity (Bq/kg)- Higher bound',
      source: 'activity_bq_kg_higher',
      ttoken: 'chem:elements.activity_bq_kg_higher',
      type: 'numeric',
      filter: true,
    }
  ],
};

export default Radionucleids;
